module.exports = __webpack_public_path__ + "img/26.d7580ec6.jpg";